import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Tips({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-6 -1 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M8.39813333 33.2125455H19.4668 8.39813333zM13.9321333.6707091c-7.12066663 0-12.91266663 5.84532726-12.91266663 13.0307273 0 4.4305818 2.19533333 8.3209636 5.534 10.6849272v3.3111637c0 1.0238909.83 1.8614363 1.84466666 1.8614363H19.4668c1.0146667 0 1.8446667-.8375454 1.8446667-1.8614363v-3.3111637c3.3386666-2.3639636 5.534-6.2543454 5.534-10.6849272 0-7.18540004-5.7926667-13.0307273-12.9133334-13.0307273zM8.39813333 35.0046909c0 1.0238909.83 1.8614364 1.84466667 1.8614364h7.3786667c1.0146666 0 1.8453333-.8375455 1.8453333-1.8614364v-5.4457273H8.39813333v5.4457273zM16.0826667 5.29436364C20.9533333 6.81203636 23.682 12.0263455 22.178 16.9406182" />
      </g>
    </svg>
  )
}

Tips.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
